module.exports = __webpack_public_path__ + "static/media/GAOFEN 7.9c9a0912.czml";